module.exports = __webpack_public_path__ + "img/vdrightarw.98adfe1d.svg";